import React from 'react';
import { Box } from '@mui/material';
import YoutubeSidebarItem from './YoutubeSidebarItem';

interface YoutubeSideMenuProps {
  activeTab: 'videos' | 'socialListening';
  setActiveTab: (tab: 'videos' | 'socialListening') => void;
}

const YoutubeSideMenu: React.FC<YoutubeSideMenuProps> = ({ activeTab, setActiveTab }) => (
  <Box
    sx={{
      width: 240,
      height: '100%',
      flexShrink: 0,
      background: '#fff',
      color: '#23272f',
      borderRight: '1px solid #f1f1f4',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontSize: 16,
      padding: 0,
      boxShadow: 'none',
    }}
  >
    <div style={{ width: '100%', padding: 0, margin: 0 }}>
      <div style={{ color: '#6c6f7f', fontWeight: 700, fontSize: 14, padding: '32px 0 8px 24px', letterSpacing: 0.2 }}>YouTube</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <div
          role="button"
          tabIndex={0}
          aria-pressed={activeTab === 'videos'}
          onClick={() => setActiveTab('videos')}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setActiveTab('videos'); }}
          style={{ cursor: 'pointer', outline: 'none' }}
        >
          <YoutubeSidebarItem
            icon="bi bi-play-btn"
            label="Videos"
            active={activeTab === 'videos'}
          />
        </div>
        <div
          role="button"
          tabIndex={0}
          aria-pressed={activeTab === 'socialListening'}
          onClick={() => setActiveTab('socialListening')}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setActiveTab('socialListening'); }}
          style={{ cursor: 'pointer', outline: 'none' }}
        >
          <YoutubeSidebarItem
            icon="bi bi-people"
            label="Social listening"
            active={activeTab === 'socialListening'}
          />
        </div>
      </div>
    </div>
  </Box>
);


export default YoutubeSideMenu;
